var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"player-selection container"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('PlayerDropdown',{attrs:{"label":"Select a player","theme":"btn-primary","players":_vm.players},on:{"select":_vm.onPlayerSelected}})],1),_c('div',{staticClass:"col"},[_c('PlayerDropdown',{attrs:{"label":"Select a opponent","theme":"btn-secondary","players":_vm.players},on:{"select":_vm.onOpponentSelected}})],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23263392","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/app/components/PlayerSelection/PlayerSelection.html
// module id = null
// module chunks = 